var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedDenied(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/close-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 1.66699C5.40834 1.66699 1.66667 5.40866 1.66667 10.0003C1.66667 14.592 5.40834 18.3337 10 18.3337C14.5917 18.3337 18.3333 14.592 18.3333 10.0003C18.3333 5.40866 14.5917 1.66699 10 1.66699ZM12.8 11.917C13.0417 12.1587 13.0417 12.5587 12.8 12.8003C12.675 12.9253 12.5167 12.9837 12.3583 12.9837C12.2 12.9837 12.0417 12.9253 11.9167 12.8003L10 10.8837L8.08334 12.8003C7.95834 12.9253 7.80001 12.9837 7.64167 12.9837C7.48334 12.9837 7.32501 12.9253 7.20001 12.8003C6.95834 12.5587 6.95834 12.1587 7.20001 11.917L9.11667 10.0003L7.20001 8.08366C6.95834 7.84199 6.95834 7.44199 7.20001 7.20033C7.44167 6.95866 7.84167 6.95866 8.08334 7.20033L10 9.11699L11.9167 7.20033C12.1583 6.95866 12.5583 6.95866 12.8 7.20033C13.0417 7.44199 13.0417 7.84199 12.8 8.08366L10.8833 10.0003L12.8 11.917Z",
    fill: "#C8171D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDenied);
export default __webpack_public_path__ + "static/media/red-denied.8d6912d01a6bd18b769d4961df4ac7a9.svg";
export { ForwardRef as ReactComponent };